import { PDFDocument } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'
import { useState } from "react"
import moment from "moment";
import constant from '../../../constant';

interface IPropType {
    detail: {
        loanId: any,
        borrowerName: any, borrowerEmail: any, borrowerSignature: any, borrowerSignatureDate: any,
        transactionNumber: any, transactionAmount: any, ctcDate: any, broker: any,
        coBorrowerName: any, coBorrowerEmail: any, coBorrowerSignature: any, coBorrowerSignatureDate: any,
        // lenderName: any,
    }
}

function HeterIskaPDF(props: IPropType) {
    const { detail } = props;
    const [stateDetail, setStateDetail]: any = useState(null);
    const [docURL, setDocURL]: any = useState(null);

    if (JSON.stringify(detail) !== JSON.stringify(stateDetail)) {
        generateBlob(detail).then((res: any) => {
            const _docURL = URL.createObjectURL(res);
            setDocURL(_docURL);
        })
        setStateDetail(detail);
    }

    if (docURL) {
        return <iframe style={{ width: '100%', height: '100%' }} src={docURL} />
    }
    return <div>Loading...</div>
}

export async function generateBlob(detail: any) {
    const fontURL = '/fonts/calibril.ttf'
    const fontBytes = await fetch(fontURL).then(res => res.arrayBuffer())

    const url = `${process.env.REACT_APP_BASE_URL}/heter-iska/penny-mac.pdf`;
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    pdfDoc.registerFontkit(fontkit)
    const customFont = await pdfDoc.embedFont(fontBytes)


    const pages = pdfDoc.getPages();
    const fontSize = 10;
    //#region page 4
    const { width, height } = pages[3].getSize()
    // date
    const _ctcDate = detail.ctcDate ? moment(detail.ctcDate) : moment();
    pages[3].drawText(
        _ctcDate.format(constant.formatting.usDateFormat),
        {
            x: 182,
            y: (height - 190),
            size: fontSize,
            font: customFont,
        });
    // receiver name
    pages[3].drawText(detail.borrowerName,
        {
            x: 182,
            y: (height - 203),
            size: fontSize,
            font: customFont,
        });
    // receiver address
    // loan id
    pages[3].drawText(detail.loanId,
        {
            x: 182,
            y: (height - 230),
            size: fontSize,
            font: customFont,
        });
    // loan date
    // pages[0].drawText('You can modify PDFs too!');
    //#endregion

    //#region page 8
    // borrowerSignature: any, borrowerSignatureDate: any,
    if (detail.borrowerSignature) {
        const pngImageBytes = await fetch(detail.borrowerSignature).then((res) => res.arrayBuffer());
        const pngImage = await pdfDoc.embedPng(pngImageBytes)
        const pngDims = pngImage.scale(0.25)
        pages[7].drawImage(pngImage, {
            x: 77,//pages[7].getWidth() / 2 - jpgDims.width / 2,
            y: pages[7].getHeight() - 368,
            // y: pages[7].getHeight() / 2 - jpgDims.height / 2,
            width: pngDims.width,
            height: pngDims.height,
        })
    }
    if (detail.borrowerSignatureDate) {
        const md = moment(detail.borrowerSignatureDate);
        pages[7].drawText(md.format('MM'), { x: 295, y: (height - 367), size: fontSize, font: customFont, });
        pages[7].drawText(md.format('DD'), { x: 320, y: (height - 367), size: fontSize, font: customFont, });
        pages[7].drawText(md.format('YYYY'), { x: 345, y: (height - 367), size: fontSize, font: customFont, });
    }
    // coBorrowerSignature, coBorrowerSignatureDate
    pages[7].drawText(detail.coBorrowerName, { x: 76, y: (height - 458), size: fontSize, font: customFont, });

    if (detail.coBorrowerSignature) {
        const pngImageBytes = await fetch(detail.coBorrowerSignature).then((res) => res.arrayBuffer());
        const pngImage = await pdfDoc.embedPng(pngImageBytes);
        const pngDims = pngImage.scale(0.25)
        pages[7].drawImage(pngImage, {
            x: 77,
            y: pages[7].getHeight() - 497,
            width: pngDims.width,
            height: pngDims.height,
        })
    }

    if (detail.coBorrowerSignatureDate) {
        const md = moment(detail.coBorrowerSignatureDate);
        pages[7].drawText(md.format('MM'), { x: 295, y: (height - 497), size: fontSize, font: customFont, });
        pages[7].drawText(md.format('DD'), { x: 320, y: (height - 497), size: fontSize, font: customFont, });
        pages[7].drawText(md.format('YYYY'), { x: 345, y: (height - 497), size: fontSize, font: customFont, });
    }
    //#endregion

    // pdfDoc.removePage(0);
    // pdfDoc.removePage(1);
    // pdfDoc.removePage(2);
    // pdfDoc.removePage(3);
    const pdfBytes = await pdfDoc.save();

    const bytes = new Uint8Array(pdfBytes);
    const blob = new Blob([bytes], { type: "application/pdf" });
    return Promise.resolve(blob);
}

export default HeterIskaPDF;